// extracted by mini-css-extract-plugin
export default {"heading":"PrivacyPolicyPage_heading__HNcyO h1","content":"PrivacyPolicyPage_content__GaLrv"};